import { createStore } from 'redux'
import rootReducer, { initialState } from "./reducers/index";


// Keeps old cached Redux state compatible with the current reducer shape.
function hydrate_cached_state(cachedState) {
    const safeCachedState = cachedState || {};
    const safeCachedUser = safeCachedState.user || {};

    return {
      ...initialState,
      ...safeCachedState,
      user: {
        ...initialState.user,
        ...safeCachedUser
      }
    };
  }

// Saves the complete Redux state so app preferences survive reloads.
function saveToLocalStorage(state) {
    try {
      const serialisedState = JSON.stringify(state);
      localStorage.setItem("persistantState", serialisedState);
    } catch (e) {
      console.warn(e);
    }
  }

// Loads cached Redux state and restores any missing default branches.
function loadFromLocalStorage() {
    try {
      const serialisedState = localStorage.getItem("persistantState");
      const cachedState = JSON.parse(serialisedState);
      return hydrate_cached_state(cachedState);
    } catch (e) {
      console.warn(e);
      return initialState;
    }
  }

const store = createStore(rootReducer, loadFromLocalStorage());

store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;
